import React, { FC, useMemo } from 'react';
import { SelectProps } from 'formik-antd/src/select/index';
import { Select } from 'formik-antd';
import { useQuery } from 'react-query';
import { QueryKey } from 'api/queryKey';
import { BusinessPartnersAPI } from 'api/BusinessPartnersAPI';
import { BusinessPartnerContext } from 'pages/BusinessPartnerManagement/BusinessPartnerContext';
import { useEnsureContext } from 'common/hooks';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

export const SubpartnersRegisterSelect: FC<SelectProps> = (props) => {
  const bpContext = useEnsureContext(BusinessPartnerContext);

  const { isFetching, data } = useQuery([QueryKey.BusinessPartnersList], () =>
    BusinessPartnersAPI.fetchSubpartners(bpContext.id)
  );

  const options = useMemo(
    () => (
      <>
        <Select.Option key={bpContext.name} value={bpContext.id}>
          {bpContext.name}
        </Select.Option>

        {data?.content.map((x: any) => (
          <Select.Option key={x.name} value={x.id}>
            {x.name}
          </Select.Option>
        ))}
      </>
    ),
    [data, bpContext.id, bpContext.name]
  );

  return (
    <Select
      {...props}
      loading={isFetching}
      defaultValue={
        props.name === 'partner-edit' && props.defaultValue !== null
          ? props.defaultValue
          : bpContext.id
      }
    >
      {options}
    </Select>
  );
};

export const SubpartnersFilterSelect: FC<SelectProps> = (props) => {
  const bpContext = useEnsureContext(BusinessPartnerContext);
  const intlMessage = useFormatMessage();

  const { isFetching, data } = useQuery([QueryKey.BusinessPartnersList], () =>
    BusinessPartnersAPI.fetchSubpartners(bpContext.id)
  );

  const options = useMemo(
    () => (
      <>
        <Select.Option key={0} value={0}>
          {intlMessage({ id: 'all' })}
        </Select.Option>
        <Select.Option key={bpContext.id} value={bpContext.id}>
          {bpContext.name}
        </Select.Option>
        {data?.content.map((x: any) => (
          <Select.Option key={x.id} value={x.id}>
            {x.name}
          </Select.Option>
        ))}
      </>
    ),
    [data, bpContext.id, bpContext.name, intlMessage]
  );

  return (
    <Select {...props} loading={isFetching}>
      {options}
    </Select>
  );
};
